var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "index-container" },
    [
      _c(
        "checkFilter",
        {
          ref: "checkFilter",
          attrs: { filter: _vm.filter, status: "Appoint" }
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.handleQuery()
                }
              }
            },
            [_vm._v("查询")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tab-content" },
        [
          _c("checkList", {
            ref: "checkList",
            attrs: { filter: _vm.filter, view: "Test" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }